(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.GraphicalComponents = Lfl.GraphicalComponents || {};

    (function (GraphicalComponents, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.GraphicalComponents, 'Graph')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * @memberOf Lfl.GraphicalComponents
         */
        Lfl.GraphicalComponents.Graph = GraphicalComponents.Graph || {};

        (function (Graph, $, undefined) {
            /*
             |==========================================================================================================
             | Object definition
             |==========================================================================================================
             */
            const SMALL_DATASET_COUNT = 5;

            const EMPTY_DATASET_COLOR = [
                'rgb(165,165,165)'
            ];

            // Note: make sure to match variables.less colors
            const SMALL_DATASET_COLORS = [
                '#f77483',
                '#ffc94f',
                '#88d0c6',
                '#c2bbed',
                '#bd7baa',
            ];

            const LARGE_DATASET_COLORS = [
                '#f77483',
                '#ff9963',
                '#ffc94f',
                '#b7d07a',
                '#88d0c6',
                '#99c7ff',
                '#c2bbed',
                '#d9b2be',
                '#bd7baa',
                '#817ab9',
            ];

            var graphs = new Map();

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /**
             * @param {object} parameters
             * @param {string} parameters.canvasId
             * @param {boolean} parameters.hasNoResponses
             * @param {array} parameters.labels
             * @param {array} parameters.data
             */
            Graph.createGraph = function (parameters) {
                var backgroundColors = getColorSet(parameters);

                if (parameters.hasNoResponses) {
                    parameters.data = [1];
                    parameters.labels = ['Žádné odpovědi'];
                }

                var chart = new Chart(parameters.canvasId, {
                    type: 'doughnut',
                    data: {
                        labels: parameters.labels,
                        datasets: [{
                            data: parameters.data,
                            backgroundColor: backgroundColors,
                        }]
                    },
                    options: {
                        responsive: true,
                        plugins: {
                            legend: {
                                display: false,
                            },
                            tooltip: {
                                displayColors: false,
                            }
                        },
                    }
                });

                graphs.set(parameters.canvasId, chart)
            };

            Graph.getGraph = function (canvasId) {
                return graphs.get(canvasId);
            }

            Graph.update = function (graph, parameters) {
                var backgroundColors = getColorSet(parameters);

                graph.data.datasets[0].data = parameters.data;
                graph.data.datasets[0].backgroundColor = backgroundColors;
                graph.data.labels = parameters.labels;

                graph.update();
            }

            Graph.clearAll = function () {
                graphs.forEach(function(graph) {
                    graph.destroy();
                })
            }

            function getColorSet(parameters) {
                var backgroundColors;

                if (parameters.hasNoResponses) {
                    backgroundColors = EMPTY_DATASET_COLOR;
                } else if (parameters.data.length <= SMALL_DATASET_COUNT) {
                    backgroundColors = SMALL_DATASET_COLORS;
                } else {
                    backgroundColors = LARGE_DATASET_COLORS;
                }

                return backgroundColors;
            }

            /*
             |----------------------------------------------------------------------------------------------------------
             | Private methods
             |----------------------------------------------------------------------------------------------------------
             */
        }(GraphicalComponents.Graph, jQuery));
    }(Lfl.GraphicalComponents, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
